<template>
  <div class="people-person" v-if="ready">
    <SiteHeader bg="false"></SiteHeader>

    <ContentSection skew="right" id="our-people" class="z-0 bg-regalblue-500 pt-16 py-20 mb-8">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-2">
          <p class="text-white text-sm font-light mt-2">
            <router-link to="/our-people">&larr; Back to people</router-link>
          </p>
        </div>
        <div class="col-span-12 sm:col-span-10">
          <h1 class="text-5xl text-white leading-none">{{ data.firstName }} {{ data.lastName }}</h1>
          <p class="pt-2 pb-2 text-white text-2xl font-light my-0">
            {{ data.title }}
          </p>
        </div>
      </div>
    </ContentSection>

    <ContentSection
      skew="none"
      id="our-people"
      class="z-20 bg-white mt-0"
      style="min-height: 400px;"
    >
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-2">
          &nbsp;
        </div>
        <div class="col-span-12 sm:col-span-6 pb-12 relative">
          <img
            :src="`/img/people/${data.slug}@2x.png`"
            :alt="`Photo of ${data.firstName} ${data.lastName}`"
            width="120"
            height="120"
            class="card-image rounded-full absolute border-white border-8"
          />
          <h2 class="text-xl font-medium text-regalblue-500 mb-2">Background</h2>
          <p v-for="(para, key) in data.summary" v-bind:key="key">{{ para }}</p>
          <p class="mt-5" v-if="data.linkedIn">
            <PhLinkedinLogo :size="28" class="inline-block align-middle mr-1" />
            <a
              :href="data.linkedIn"
              target="_blank"
              class="text-astralblue-500 underline hover:text-astralblue-700"
              :title="`Connect with ${data.firstName} on LinkedIn.`"
              >Connect with {{ data.firstName }} on LinkedIn.</a
            >
          </p>

          <div v-show="$route.params.person === 'ian_wilson'">
            <div class="shadow-2xl p-3 sm:p-8 mt-10 rounded-sm border border-grey-50">
              <h2 class="text-xl font-medium text-regalblue-500">
                A spotlight on {{ data.firstName }}
              </h2>
              <dl>
                <dt>Q: What advice do you have for prospective Pipefish candidates?</dt>
                <dd>
                  A: We are a great team and people enjoy what they do and are committed to
                  delivering quality outcomes for our clients
                </dd>
                <dt>Q: What are 3 words to describe Pipefish?</dt>
                <dd>A: Talented, Committed, Supportive</dd>
                <dt>Q: What have you gained from working at Pipefish?</dt>
                <dd>
                  A: The confidence in my own abilities and the knowledge that no challenge is
                  insurmountable when you have a collaborative and supportive team around you
                </dd>
                <dt>Q: Do you have a favourite quote?</dt>
                <dd>A: “The only stupid question is the question that's not asked”</dd>
                <dt>
                  Q: What is the most important thing you have learned in the last five years?
                </dt>
                <dd>
                  A: That we all sit somewhere on the Introversion/Extroversion scale and being an
                  Introvert doesn't mean you can't be extroverted (and vice versa) It just means you
                  have to take time for yourself to recharge and get back to your happy place on the
                  Introvert/Extrovert scale. It’s a concept by Susan Cain from her book Quiet: The
                  Power of Introverts in a World That Can't Stop Talking
                </dd>
                <dt>Q: What is the top played song on your playlist?</dt>
                <dd>
                  A: Oceantides by Dreamshade or anything really from the Vibrant album. Also
                  anything from Tool is always up there!
                </dd>
              </dl>
            </div>
          </div>

          <div v-show="$route.params.person === 'hamish_beattie'">
            <div class="shadow-2xl p-3 sm:p-8 mt-10 rounded-sm border border-grey-50">
              <h2 class="text-xl font-medium text-regalblue-500">
                A spotlight on {{ data.firstName }}
              </h2>
              <dl>
                <dt>Q: What are three words to describe Pipefish?</dt>
                <dd>
                  A: Transparent, Collaborative and Unicorn
                </dd>
                <dt>Q: What is the favourite part about working for Pipefish?</dt>
                <dd>
                  A: Having the opportunity to work with some of the brightest people in the
                  industry.
                </dd>
                <dt>Q: What is on your wish list for the next 5 years with Pipefish?</dt>
                <dd>
                  A: To continue to grow the user experience services and offerings at Pipefish.
                </dd>
                <dt>Q: What would you most like to tell yourself at age 13?</dt>
                <dd>
                  A: Do all your world travelling before 2020
                </dd>
                <dt>Q: What tv show/movie are you ashamed to admit you love?</dt>
                <dd>
                  A: I have recently fallen the victim of Korean dramas… They are so addictive.
                  “Crash Landing on you” is a must see.
                </dd>
                <dt>
                  Q: What would you do (for a career) if you weren’t doing this?
                </dt>
                <dd>
                  A: Artist specialising in sculpture
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-4">
          <div class="md:pl-12 leading-5 people-list">
            <h3 class="text-sm text-grey-800 mb-2">Our people</h3>

            <div class="flex-2col pl-0">
              <div class="flex-item flex-col" v-for="person in peopleData" v-bind:key="person.slug">
                <router-link
                  :to="{ name: 'people-person', params: { person: person.slug } }"
                  class="text-xs text-grey-700 underline hover:text-astralblue-700 mr-1 block"
                >
                  {{ person.firstName }} {{ person.lastName }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 relative">
        <div class="col-span-12 sm:col-span-2">
          &nbsp;
        </div>
        <div class="col-span-12 sm:col-span-10">
          <p class="text-sm font-light text-regalblue-500">
            <!-- <router-link to="/our-people">&larr; Back to people</router-link> -->
          </p>
        </div>
        <!-- <pre>{{ data }}</pre> -->
      </div>
    </ContentSection>

    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/Footer.vue';
import ContentSection from '@/components/ContentSection.vue';
import _ from 'lodash';
import '@/components/svg/icon-check';
import '@/components/svg/chevron-left';
import '@/components/svg/chevron-right';
import '@/components/svg/footer-contact-us';
import { PhLinkedinLogo } from 'phosphor-vue';

export default {
  name: 'CaseStudies',
  components: {
    SiteHeader,
    SiteFooter,
    ContentSection,
    PhLinkedinLogo
  },
  data: function() {
    return {
      ready: false,
      data: null,
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    toggleContactUsModal: function(title) {
      // this.$store.dispatch('toggleContactUsModal');
      // this.Store.dispatch('toggleContactUsModal', { title: title });
      this.Store.toggleContactUsModal({ title: title });
    },
    getData: function() {
      var vm = this;
      vm.peopleData = _.sortBy(vm.Store.people, [
        function(o) {
          return o.lastName;
        }
      ]);

      vm.data = _.find(vm.peopleData, function(item) {
        return item.slug === vm.$route.params.person;
      });
      this.ready = true;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getData();
      // setTimeout(function() {
      //   this.sticky = new Sticky('.csSidebar');
      // }, 300);
    });
  }
};
</script>

<style lang="scss">
.people-person {
  p {
    @apply my-3 text-base leading-7;
  }
  dl {
    @apply my-5 text-base leading-6;
    dt {
      @apply font-bold text-astralblue-700;
    }
    dd {
      @apply mb-5;
    }
  }
  .card-image {
    top: 0;
    right: 0;
    left: 50%;
    transform: translateX(-50%) translateY(-105%);
    width: 140px;
    height: 140px;
    @include media('>=640px') {
      left: auto;
      transform: translateX(0) translateY(-85%);
      width: 160px;
      height: 160px;
    }
  }
  .people-list {
    a.router-link-exact-active {
      @apply font-bold;
    }
  }
}
</style>
